import './polyfills'; //Must be imported as first line!!!!
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import rg4js from 'raygun4js';
import 'semantic-ui-less/semantic.less'
import React from 'react';
import {render} from 'react-dom';
import {AppContainer} from 'react-hot-loader';
import AppConfig from './app-config';
import App from './components/App';
import configureStore from './redux/configureStore';

import './index.css';

console.log('Launching build number ' + AppConfig.buildNumber);

if (AppConfig && AppConfig.env !== 'local') {
  if (AppConfig && AppConfig.logRocketAppId)
    LogRocket.init(AppConfig.logRocketAppId, {
      release: AppConfig.buildNumber
    });

  setupLogRocketReact(LogRocket);
}


if (AppConfig.raygunApiKey) {
  console.log('Using Raygun');
  rg4js('apiKey', AppConfig.raygunApiKey);
  rg4js('enableCrashReporting', true);
  rg4js('logContentsOfXhrCalls', true)
  rg4js('setVersion', AppConfig.buildNumber);
}

const store = configureStore();

// if (AppConfig.raygunApiKey) {
//   rg4js('withCustomData', () => {
//     const state = store.getState();
//
//     return {state};
//   });
// }
render(
    <AppContainer>
      <App store={store}/>
    </AppContainer>,
    document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NewRoot = require('./components/App').default;
    render(
        <AppContainer>
          <NewRoot store={store}/>
        </AppContainer>,
        document.getElementById('root')
    );
  });
}

